import { StopPayload } from "./stopPayload";

export const SortStopIndexes = (stops) => {
  return stops?.map((s, index) => {
    return StopPayload(s).updateIndex(index);
  });
};
